import { InstructorAssessmentView } from "./InstructorAssessmentView";
import { StudentAssessmentView } from "./StudentAssessmentView";

import { SectionScoreTableProvider } from "providers/SectionScoreTableProvider";
import { useCanAccessStudentSectionScores, useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentUserId } from "store/selectors";

export const SectionAssessmentMainView = () => {
  const currentUserId = useAppSelector(selectCurrentUserId);
  const { canAuthorSection } = useCapabilities();
  const canAccessStudentSectionScores = useCanAccessStudentSectionScores();

  if (!currentUserId) {
    return null;
  }

  return (
    <SectionScoreTableProvider>
      <div className="flex flex-col gap-6 text-xs">
        {canAccessStudentSectionScores ? (
          <StudentAssessmentView userId={currentUserId} />
        ) : canAuthorSection ? (
          <InstructorAssessmentView />
        ) : null}
      </div>
    </SectionScoreTableProvider>
  );
};
